import React, { useState } from 'react'
import '../Sidebar/Sidebar.css'
import { NavLink } from 'react-router-dom'
import { RxDashboard } from 'react-icons/rx'
import { FiUser } from 'react-icons/fi'
import { MdOutlineCategory, MdProductionQuantityLimits } from 'react-icons/md'
import { BiCoinStack } from 'react-icons/bi'
import { FiLogOut } from 'react-icons/fi'
import Logout from '../../Pages/LogOut/Logout'
import { APP_VERSION } from '../../Pages/Version Provider/VersionConfig'

const Sidebar = ({ setPageTitle }) => {
  const [isOpen] = useState(true); 
  const [showLogout, setShowLogout] = useState(false);
    const [versionCode] = useState(APP_VERSION);

  return (
    <>
      <div className={`sidebar-container ${isOpen ? "open" : "closed"}`}>
        <div className="sidebar-content">
          <ul>
            <NavLink to="/admin/dashboard" onClick={() => setPageTitle("Dashboard")}>
              <li><RxDashboard className='sidebar-icons'/>{isOpen && "Dashboard"}</li>
            </NavLink>
            <NavLink to="/admin/customers-list" onClick={() => setPageTitle("Customers List")}>
              <li><FiUser className='sidebar-icons'/>{isOpen && "Customers List"}</li>
            </NavLink>
            <NavLink to="/admin/category-list" onClick={() => setPageTitle("Category List")}>
              <li><MdOutlineCategory className='sidebar-icons'/>{isOpen && "Category List"}</li>
            </NavLink>
            <NavLink to="/admin/product-list" onClick={() => setPageTitle("Product List")}>
              <li><MdProductionQuantityLimits className='sidebar-icons'/>{isOpen && "Product List"}</li>
            </NavLink>
            <NavLink to="/admin/coin-allot" onClick={() => setPageTitle("Coin Allot")}>
              <li><BiCoinStack className='sidebar-icons'/>{isOpen && "Coin Allot"}</li>
            </NavLink>

            {/* Logout button */}
            <li className="logout-link" onClick={() => setShowLogout(true)}>
              <FiLogOut className='sidebar-icons'/>
              {isOpen && "Logout"}
            </li>

          </ul>
        </div>
                <p style={{marginTop:"270px",color:"white",textAlign:"center"}}>Version {versionCode}</p>
      </div>

      {/* Show Logout Modal */}
      {showLogout && <Logout onClose={() => setShowLogout(false)} />}

    </>
  )
}

export default Sidebar
